export const FETCH_SEO_SETTING_REQUEST = "FETCH_SEO_SETTING_REQUEST";
export const UPDATE_SEO_SETTING_REQUEST = "UPDATE_SEO_SETTING_REQUEST";
export const CREATE_SEO_SETTING_REQUEST = "CREATE_SEO_SETTING_REQUEST";
